import { LIKE_TWEET } from "./constants";

export const handleLikeTweet = id => {
  return {
    type: LIKE_TWEET,
    payload: {
      id
    }
  };
};
